export enum PriceFilterDefault {
    Min = 10,
    Max = 500,
}
